// extracted by mini-css-extract-plugin
module.exports = {"interest":"interest_interest__3g7mZ","title":"interest_title__2gwVx","gauge":"interest_gauge__2ly08","level":"interest_level__QywTU","modal-title":"interest_modal-title__14OWi"};